import React                   from 'react'
import { connect }             from 'react-redux'
import i18n                    from '../../i18n'
import { trackingEvent }       from '../pages/layouts/GoogleAnalytics'
import { loginApiUrl }         from '../../actions/config'
import { mapDispatchToProps }  from "../mapDispatchToProps"
import withBaseComponent       from '../withBaseComponent';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ToastHelper             from '../../util/toast-helper'

class UserSetting extends withBaseComponent(React.Component) {
  gotoEditEmail() {
    trackingEvent("User", "メールアドレスの変更")
    window.location.href = `${loginApiUrl}email/edit`
  }

  gotoEditPassword() {
    trackingEvent("User", "パスワードの変更")
    window.location.href = `${loginApiUrl}password/edit`
  }

  confirmWithdraw() {
    this.toggleModal()
  }

  withdrawUser() {
    this.props.userActions.withdrawUser().then((res) => {
      localStorage.removeItem('mf_authorization')
      localStorage.removeItem('oauth_authorize')
      localStorage.removeItem("refererUrl")
      this.props.sessionActions.defaultSession({isFetchingSession: false})
      window.location.href = "/"
    }).catch((error) => {
      ToastHelper.error('問題が発生したため処理を中断しました。時間をおいて再度お試しください。')
      return error;
    });
  }

  render() {
    return (
      <div className="small-container" id="user-container">
        <div className="row no-gutters">
          <div className="col-sm-9 title padl-0">メールアドレス・パスワードの変更</div>
          <div className="col-sm-12 content-body">
            <button className="item btn-link normal" onClick={() => this.gotoEditEmail()}>
              {i18n.t('header.edit_email')}
            </button>
            <hr className='line'/>
            <button className="item btn-link normal" onClick={() => this.gotoEditPassword()}>
              {i18n.t('header.edit_password')}
            </button>
          </div>
        </div>
        <div className="row no-gutters">
          <div className="col-sm-9 title padl-0">退会手続き</div>
          <div className="col-sm-12 content-body">
            <div className="row align-items-center">
              <div className='title'>退会に関する注意事項</div>
              <ul>
                <li>退会するとマネーフォワード 明細連携の事業者情報は削除されます。削除後の復旧はできませんので、あらかじめご了承ください。</li>
                <li>マネーフォワード 明細連携と他サービスと連携している場合、連携は解除されます。</li>
                <li>マネーフォワード 明細連携のアカウントは削除されますが、「マネーフォワード ID」の登録は退会されません。あわせて退会をご希望される場合は
                  <a href={`${loginApiUrl}helps`}>こちら</a>をご確認ください。
                </li>
              </ul>
              <button type="button" onClick={() => this.confirmWithdraw() } className="btn mfc-btn-gray mfc-btn-danger">マネーフォワード 明細連携から退会</button>
            </div>
          </div>
        </div>
        <Modal isOpen={this.state.isOpenModal} className={this.props.className} centered={true}>
          <ModalHeader toggle={this.toggleModal}>
            マネーフォワード 明細連携から退会
          </ModalHeader>
          <ModalBody>
            <div className="form-group">
              マネーフォワード 明細連携から退会します。よろしいですか？
            </div>
          </ModalBody>
          <ModalFooter>
            <Button onClick={this.toggleModal} className="btn mfc-btn-gray medium">{i18n.t('common.cancel')}</Button>
            <button className={`btn mfc-btn-red`} onClick={() => this.withdrawUser()}>
              退会
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

function mapStateToProps() {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserSetting)
